import { render, staticRenderFns } from "./AccountSettingsMenuItem.vue?vue&type=template&id=2bca5a87&"
import script from "./AccountSettingsMenuItem.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports